import React, { useContext } from 'react';
import { DropdownMenu, Card, Row, Col } from '@paypalcorp/pp-react';
import styles from '../Configurator.module.less';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import { trackFieldChange, trackFieldFocus, trackFieldClosed } from '../../../lib/fpti';

export default function SdkConfigurator() {
  const FTPI_BUYER_COUNTRY = 'Buyer Country';
  const FTPI_CURRENCY = 'Currency:SDK';

  const {
    SdkConfigurator: { sdkSettings, buyerCountryOptions, buyerCurrencyOptions, updateSdkSettings }
  } = useContext(IntegrationPageSectionContext);

  function onValueChange(event, key, ftpiIdentifier) {
    const newValue = event.target.value;
    trackFieldChange(ftpiIdentifier, newValue);
    updateSdkSettings(newValue, key);
  }

  return (
    <div className={styles.card_container}>
      <Card>
        <div className={styles.card_header}>Country and currency:</div>
        <Card.Content>
          The Buyer Country field is intended solely for sandbox testing purposes and should not be
          utilized in production environments.
        </Card.Content>
        <div className={styles.configuration}>
          <Row>
            <Col lg={7}>
              <div className={styles.configuration_item}>
                <DropdownMenu
                  label="Buyer Country"
                  className={styles.horizontal_configuration_dropdown}
                  options={buyerCountryOptions}
                  value={sdkSettings.buyerCountry}
                  onClick={() => trackFieldFocus(FTPI_BUYER_COUNTRY)}
                  onChange={(e) => onValueChange(e, 'buyerCountry', FTPI_BUYER_COUNTRY)}
                  onClose={() => trackFieldClosed(FTPI_BUYER_COUNTRY)}
                />
              </div>
            </Col>
            <Col lg={5}>
              <div className={styles.configuration_item}>
                <DropdownMenu
                  label="Currency"
                  className={styles.horizontal_configuration_dropdown}
                  options={buyerCurrencyOptions}
                  value={sdkSettings.currency}
                  onClick={() => trackFieldFocus(FTPI_CURRENCY)}
                  onChange={(e) => onValueChange(e, 'currency', FTPI_CURRENCY)}
                  onClose={() => trackFieldClosed(FTPI_CURRENCY)}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );
}
